<table class="w-full text-left rtl:text-right text-gray-500">
	<thead [ngClass]="isClientFacingRoute ? 'blue-bg text-white' : 'bg-white text-black'" class="semi-bold text-xs top-0 z-10 shadow">
		<tr>
			<th *ngIf="holdAndUserIsAudioContentCreator" class="px-2 py-2"></th>
			<th *ngIf="showIdColumn" class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'Id', direction: sortConfig.direction })">
				ID
				<i [class]="getSortIconClass('Id')" class="ml-1"></i>
			</th>
			<th
				*ngIf="!isClientFacingRoute"
				class="px-2 py-2 cursor-pointer"
				(click)="handleSortClick.emit({ column: 'ClientName', direction: sortConfig.direction })"
			>
				Client Name
				<i [class]="getSortIconClass('ClientName')" class="ml-1"></i>
			</th>
			<th *ngIf="isClientFacingRoute" class="px-2 py-2"></th>
			<th class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'Title', direction: sortConfig.direction })">
				Title
				<i [class]="getSortIconClass('Title')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'ClipCount', direction: sortConfig.direction })">
				{{ isClientFacingRoute ? 'Messages' : 'Clips' }}
				<i [class]="getSortIconClass('ClipCount')" class="ml-1"></i>
			</th>
			<th
				*ngIf="showRequestTypeColumn"
				class="px-2 py-2 cursor-pointer"
				(click)="handleSortClick.emit({ column: 'RequestType', direction: sortConfig.direction })"
			>
				Type
				<i [class]="getSortIconClass('RequestType')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'CreateDateTime', direction: sortConfig.direction })">
				Created
				<i [class]="getSortIconClass('CreateDateTime')" class="ml-1"></i>
			</th>
			<th *ngIf="!isClientFacingRoute" class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'DueDate', direction: sortConfig.direction })">
				Due
				<i [class]="getSortIconClass('DueDate')" class="ml-1"></i>
			</th>
			<th
				*ngIf="selectedRequestTypeIsVideoOrAll"
				class="px-2 py-2 cursor-pointer"
				(click)="handleSortClick.emit({ column: 'ApprovedDateTime', direction: sortConfig.direction })"
			>
				Approved
				<i [class]="getSortIconClass('ApprovedDateTime')" class="ml-1"></i>
			</th>
			<th
				*ngIf="showVoiceTalentColumn"
				class="px-2 py-2 cursor-pointer"
				(click)="handleSortClick.emit({ column: 'VoiceTalent', direction: sortConfig.direction })"
			>
				Voice
				<i [class]="getSortIconClass('VoiceTalent')" class="ml-1"></i>
			</th>
			<th *ngIf="!isClientFacingRoute" class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'CsrName', direction: sortConfig.direction })">
				Csr
				<i [class]="getSortIconClass('CsrName')" class="ml-1"></i>
			</th>
			<th
				*ngIf="selectedRequestTypeIsVideoOrAll"
				class="px-2 py-2 cursor-pointer"
				(click)="handleSortClick.emit({ column: 'ProducerName', direction: sortConfig.direction })"
			>
				Producer
				<i [class]="getSortIconClass('ProducerName')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'RequestedByName', direction: sortConfig.direction })">
				Requested By
				<i [class]="getSortIconClass('RequestedByName')" class="ml-1"></i>
			</th>
			<th class="px-2 py-2 cursor-pointer" (click)="handleSortClick.emit({ column: 'StateName', direction: sortConfig.direction })">
				Status
				<i [class]="getSortIconClass('StateName')" class="ml-1"></i>
			</th>
		</tr>
	</thead>
	<tbody class="shadow">
		<tr
			*ngFor="
				let request of contentRequestsService.requests
					| paginate
						: {
								itemsPerPage: itemsPerPage,
								currentPage: viewStateService.pageNumber,
								totalItems: viewStateService.totalItems
						  }
			"
			[ngClass]="rowBgColor(request)"
			class="text-black border-b text-[12px] xl:text-sm hover:opacity-80 cursor-pointer"
			(click)="handleRowSelect.emit(request)"
		>
			<td *ngIf="holdAndUserIsAudioContentCreator" class="py-2 px-2">
				<input
					id="checkbox-1"
					type="checkbox"
					(change)="mergeRequestsService.onCheckboxClick(request)"
					(click)="$event.stopPropagation()"
					value=""
					class="relative z-10 w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500"
				/>
			</td>
			<td *ngIf="showIdColumn" class="py-2 px-2">
				<p>{{ request.Id }}</p>
			</td>
			<td *ngIf="!isClientFacingRoute" class="py-2 px-2 semi-bold">
				<p>{{ request.ClientName }}</p>
			</td>
			<td *ngIf="isClientFacingRoute" class="py-2 px-2">
				<button
					(click)="handleRowSelect.emit(request)"
					class="px-4 !w-auto text-black bg-gray-200 focus:outline-hidden hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded text-sm py-2.5 me-2"
				>
					View
				</button>
			</td>
			<td class="py-2 px-2">
				<p>{{ request.Title }}</p>
			</td>
			<td class="py-2 px-2">
				<p>{{ request.ClipCount }}</p>
			</td>
			<td *ngIf="showRequestTypeColumn" class="py-2 px-2">
				<p>{{ request.RequestType }}</p>
			</td>
			<td class="py-2 px-2">
				<p>{{ request.CreateDateTime | date : 'M/d/yyyy' }}</p>
			</td>
			<td *ngIf="!isClientFacingRoute" class="py-2 px-2">
				<p>{{ request.DueDate | date : 'M/d/yyyy' }}</p>
			</td>
			<td *ngIf="selectedRequestTypeIsVideoOrAll" class="py-2 px-2">
				<p>{{ request.ApprovedDateTime ? (request.ApprovedDateTime | date : 'M/d/yyyy') : 'N/A' }}</p>
			</td>
			<td *ngIf="showVoiceTalentColumn" class="py-2 px-2">
				<p>{{ request.VoiceTalent }}</p>
			</td>
			<td *ngIf="!isClientFacingRoute" class="py-2 px-2">
				<p>{{ request.CsrName }}</p>
			</td>
			<td *ngIf="selectedRequestTypeIsVideoOrAll" class="py-2 px-2">
				<p>{{ request.ProducerName }}</p>
			</td>
			<td class="py-2 px-2">
				<p>{{ request.RequestedByName }}</p>
			</td>
			<td class="py-2 px-2">
				<p *ngIf="!isClientFacingRoute">{{ request.StateName }}</p>
				<p *ngIf="isClientFacingRoute">{{ request.clientStatusView }}</p>
			</td>
		</tr>
	</tbody>
</table>

<div *ngIf="showPagination" class="flex justify-between items-center mt-2 mb-[100px]">
	<div>
		<pagination-controls (pageChange)="handlePaginationClick.emit($event)" class="pagination"></pagination-controls>
	</div>
	<div *ngIf="viewStateService.totalItems">
		<span class="semi-bold">Total Items:</span>
		{{ viewStateService.totalItems }}
	</div>
</div>
